import {DatePicker} from 'primeng/datepicker';
import {DialogService, DynamicDialogConfig} from 'primeng/dynamicdialog';

/**
 * Desde PrimeNG 17 el calendario deja el input vacío si el valor cae fuera de [minDate, maxDate], comparando hasta el
 * milisegundo. Con límites calculados con new Date() (hoy, ahora) el valor de "hoy" queda unos milisegundos fuera y no
 * se ve aunque el formulario lo tenga. En calendarios solo de fecha los límites son días, como mostraba la 16.
 * El método solo decide qué se muestra en el input; la selección sigue validándose por día en el propio componente.
 */
const dia = (fecha: Date): number => new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime();

const original = (DatePicker.prototype as any).isValidDateForTimeConstraints;
(DatePicker.prototype as any).isValidDateForTimeConstraints = function (fecha: Date): boolean {
    if (this.showTime || this.timeOnly || !(fecha instanceof Date)) {
        return original.call(this, fecha);
    }
    return (!this.minDate || dia(fecha) >= dia(this.minDate)) && (!this.maxDate || dia(fecha) <= dia(this.maxDate));
};

/**
 * En PrimeNG 16 los modales abiertos con DialogService mostraban la X de cerrar salvo closable: false; desde la 17
 * solo con closable: true. Ninguna llamada lo indica, así que se recupera el comportamiento de la 16 respetando un
 * closable explícito.
 */
const abrir = DialogService.prototype.open;
DialogService.prototype.open = function (componentType: any, config: DynamicDialogConfig = {}) {
    return abrir.call(this, componentType, {closable: true, closeAriaLabel: 'Cerrar', ...config});
};
